module.exports = __webpack_public_path__ + "img/website.14585b5a.svg";